/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAuthorizedAccount} from '../api'

 export const useQueryGetAuthorizedAccount = createReactQueryHook('getAuthorizedAccount', getAuthorizedAccount)
